// import { handleTransition } from "@/utils/view-transitions";

const AUTO_PROGRESS_DELAY = 4000; // ms between slides

const creatAutoProgressor = (onProgress: () => void) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const start = () => {
    stop();
    timeoutId = setTimeout(() => {
      onProgress();

      start(); // Schedule next
    }, AUTO_PROGRESS_DELAY);
  };

  const stop = () => {
    if (!timeoutId) return;
    clearTimeout(timeoutId);
    timeoutId = null;
  };

  const reset = () => start();

  return { start, stop, reset };
};

type AutoProgressor = ReturnType<typeof creatAutoProgressor>;

export { creatAutoProgressor, type AutoProgressor };
